import { gql } from '@apollo/client/core';

export const category = gql`
  fragment CategoryFragment on Category {
    id
    icon
    parent {
      id
    }
    seo {
      header
      metaTag
    }
    title
    adult
  }
`;

export const currentCategory = gql`
  fragment CategoryShortFragment on Category {
    id
    parent {
      id
      title
    }
    title
  }
`;

export const fastCategory = gql`
  fragment FastCategoryFragment on Category {
    id
    parent {
      id
      title
    }
    title
    seo {
      header
      metaTag
    }
  }
`;
